import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosClient, getBaseUrlVersioned } from "../../services/axiosClient";
import { API_VERSION } from "../types";
import { GroupchatFlow } from "./types";
const GROUPS_PAGE_LIMIT = 50;
export const getGroupchats = createAsyncThunk("groupchat/getAll", async (params, thunkAPI) => {
    try {
        const urlParams = new URLSearchParams();
        urlParams.set("switch", "T1");
        urlParams.set("type", "META");
        urlParams.set("limit", String(GROUPS_PAGE_LIMIT));
        if (params?.lastKey)
            urlParams.set("lastKey", params.lastKey);
        if (params?.sort)
            urlParams.set("sort", params.sort);
        if (params?.search)
            urlParams.set("search", params.search);
        if (params?.filter)
            urlParams.set("filter", params.filter);
        if (params?.includeAttachedLorebookId)
            urlParams.set("includeAttachedLorebookId", "true");
        if (params?.triggerError)
            urlParams.set("triggerError", "true");
        const apiUrl = `${getBaseUrlVersioned(API_VERSION.V2)}/users/characters?${urlParams.toString()}`;
        const response = await axiosClient.get(apiUrl);
        const responseData = response.data;
        const groupchats = Array.isArray(responseData?.data) ? responseData.data : [];
        const hasNextPage = groupchats.length >= GROUPS_PAGE_LIMIT && responseData?.lastKey != null;
        const lastKey = hasNextPage ? JSON.stringify(responseData.lastKey) : undefined;
        return { groupchats, lastKey };
    }
    catch (error) {
        throw thunkAPI.rejectWithValue(error?.response?.data || "Failed to fetch groupchats");
    }
});
const initialState = {
    loading: false,
    loadingType: null,
    groupchatsData: null,
    lastKey: null,
};
const handlePending = (state, loadingType) => {
    state.loading = true;
    state.loadingType = loadingType;
};
const handleFulfilled = (state) => {
    state.loading = false;
    state.loadingType = null;
};
const handleRejected = (state) => {
    state.loading = false;
    state.loadingType = null;
};
export const groupchatSlice = createSlice({
    name: "groupchat",
    initialState: initialState,
    reducers: {
        clearGroupchatLoading: (state) => {
            state.loading = false;
            state.loadingType = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getGroupchats.pending, (state) => {
            handlePending(state, GroupchatFlow.GET_GROUPCHATS);
        });
        builder.addCase(getGroupchats.fulfilled, (state, action) => {
            handleFulfilled(state);
            state.groupchatsData = action.payload.groupchats;
            state.lastKey = action.payload.lastKey ?? null;
        });
        builder.addCase(getGroupchats.rejected, (state) => {
            handleRejected(state);
        });
    },
});
export const { clearGroupchatLoading } = groupchatSlice.actions;
export default groupchatSlice.reducer;
